import {
  Box,
  Card,
  Flex,
  Icon,
  Text,
  Heading,
  FormLabel,
  IconButton,
  FormControl,
  CurrencyInput
} from '@homebotapp/hb-react-component-catalog'
import { useState } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { formatCurrency } from '../../../../../../helpers/formatters'

export const MSG = defineMessages({
  propertyTaxes: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxes',
    defaultMessage: 'Property taxes'
  },
  propertyTaxesDescription: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxesDescription',
    defaultMessage: 'Based on historical data'
  },
  hide: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxesHide',
    defaultMessage: 'Hide editable fields'
  },
  show: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxesShow',
    defaultMessage: 'Show editable fields'
  },
  monthlyAmount: {
    id: 'EstimatedMonthlyPaymentBreakdown.monthlyAmount',
    defaultMessage: 'Monthly amount'
  }
})

export interface EstimatedMonthlyPaymentBreakdownPropertyTaxesProps {
  propertyTaxes: string
  setPropertyTaxes: (value: string) => void
  setHasUsedMortgageCalculator: (value: boolean) => void
}

export const EstimatedMonthlyPaymentBreakdownPropertyTaxes = ({
  propertyTaxes,
  setPropertyTaxes,
  setHasUsedMortgageCalculator
}: EstimatedMonthlyPaymentBreakdownPropertyTaxesProps) => {
  const intl = useIntl()
  const [showEditableFields, setShowEditableFields] = useState(false)

  return (
    <Card p={3}>
      <Flex justify='space-between' align='center'>
        <Flex gap={2} align='center'>
          {/* @TODO:DESIGNSYSTEM - add purple ramp */}
          {/* @ts-ignore */}
          <Box bg='#9770F7' width={3} height={3} borderRadius='50%' />
          <Heading as='h4' size={['2xs', 'xs', 'sm']}>
            {intl.formatMessage(MSG.propertyTaxes)}
          </Heading>
        </Flex>
        <Flex>
          <Text
            mb={0}
            color='neutral.900'
            size={['xs', 'sm', 'md']}
            fontWeight='semibold'
            style={{ fontVariant: 'tabular-nums' }}
          >
            {formatCurrency(propertyTaxes)}
          </Text>
          <IconButton
            size='xs'
            variant='link'
            onClick={() => setShowEditableFields(!showEditableFields)}
            aria-label={intl.formatMessage(showEditableFields ? MSG.hide : MSG.show)}
            icon={<Icon height={2} name='play' transform={`rotate(${showEditableFields ? -90 : 90}deg)`} />}
            tracking={{
              guid: 'rFt1SGmgVuBsj4hR523Vkh',
              ui_context: 'Listing Details Page Mortgage Calculator',
              descriptor: `Property Taxes ${showEditableFields ? 'Hide' : 'Show'}`
            }}
          />
        </Flex>
      </Flex>
      <Text ml={5} as='span' size={['2xs', 'xs', 'sm']} display='block'>
        {intl.formatMessage(MSG.propertyTaxesDescription)}
      </Text>
      {showEditableFields && (
        <FormControl mt={4}>
          <FormLabel size='xs'>{intl.formatMessage(MSG.monthlyAmount)}</FormLabel>
          <CurrencyInput
            size='xs'
            maxWidth='250px'
            decimalScale={2}
            name='propertyTaxes'
            defaultValue={propertyTaxes}
            // @ts-ignore
            onChange={val => setPropertyTaxes(val)}
            onFocus={() => setHasUsedMortgageCalculator(true)}
            tracking={{
              descriptor: 'Property Taxes',
              guid: 'bWp13f4waN2hDGSM1PXz3c',
              ui_context: 'Listing Details Page Mortgage Calculator'
            }}
          />
        </FormControl>
      )}
    </Card>
  )
}
